import { Calendar } from "@fullcalendar/core";
import timeGridPlugin from "@fullcalendar/timegrid";

export class WeekCalendar {
  static generate() {
    let calendarEl = document.getElementById("week-calendar");
    if (calendarEl == null) { return }
    let calendarEvents = $('#calendar-events').data('events');
    let date = $('#calendar-date').data('date');
    let initData = $('#calendar-init').data('init');

    let calendar = new Calendar(calendarEl, {
      plugins: [timeGridPlugin],
      initialDate: date,
      headerToolbar:{ left: '', center: '', right: '' },
      height: 'auto',
      eventTextColor: '#464646',
      eventBackgroundColor: '#fff',
      dayHeaderDidMount: this._dayHeaderDidMount(),
      events: calendarEvents,
      eventContent: this._eventContent(),
      eventDidMount: this._eventDidMount(),
      locale: "ja",
      slotEventOverlap: false,
      allDaySlot: false,
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
      },
      slotDuration: `00:${initData['koma_time']}:00`,
      slotLabelInterval: `00:${initData['koma_time']}`,
      slotMinTime: initData['start_time'],
      slotMaxTime: initData['end_time'],
      // TODO: 下記はデザイン当て込み前の動作確認用に追加しているものとなります。デザイン当て込み後は不要となるので削除。
      slotLabelClassNames: function(arg) {
        return [ 'tmp-height' ]
      },
    });

    calendar.render();

    return calendar;
  }

  static _dayHeaderDidMount() {
    return function(arg) {
      let dayLinkEl = arg.el.getElementsByClassName('fc-col-header-cell-cushion')[0];
      let url = location.href.split('?')[0];
      let params = new URLSearchParams(location.search)
      let date = arg.date.toLocaleDateString();
      params.set('calendar_type', 'day')
      params.set('date', date)
      dayLinkEl.setAttribute('href', `${url}?${params.toString()}`);
    }
  };

  static _eventContent() {
    const registrationEvent = this._registrationEvent;
    const calendarEvent = this._calendarEvent;
    return function(arg) {
      let extendedProps = arg.event.extendedProps
      let type = extendedProps.type
      if (type == 'registration') {
        return registrationEvent(extendedProps);
      } else {
        return calendarEvent(extendedProps);
      }
    }
  };

  // Waitlist登録用のボタンをカレンダーのeventとして生成
  static _registrationEvent(extendedProps) {
    let eventContent = `
      <a class="btn btn-register modal-open js-btn-add-waitlist" data-toggle="modal" data-target="#newWaitlistModal" data-date="${extendedProps.date}" data-is-am=${extendedProps.am} data-is-pm=${extendedProps.pm} href="#">+</a>
    `;
    return {html: eventContent}
  };

  // Waitlistの情報をまとめたカレンダーのevent
  static _calendarEvent(extendedProps) {
    let images = extendedProps.card_images.map(function(image){
      return `
        <a data-lightbox=${extendedProps.id} href=${image}>
          <img src=${image}>
        </a>
      `;
    }).join('');
    let eventContent = `
      <p>${extendedProps.hospital_card_number}</p>
      <p>${extendedProps.name}</p>
      <p>${extendedProps.required_item}</p>
      ${images}
    `;
    return {html: eventContent}
  };

  static _eventDidMount() {
    return function(arg) {
      let addWaitlistBtnEl = arg.el.getElementsByClassName('js-btn-add-waitlist')[0];
      if (addWaitlistBtnEl == null) return;
      [...Array(2)].map(() => $(addWaitlistBtnEl).unwrap());
      arg.el.classList.remove(...arg.el.classList)
    }
  }
}
